export class DateFormatModel{
    DayOfWeek: boolean; 
    Month: boolean; 
    DayOfMonth: boolean; 
    Year:boolean; 
    Time: boolean;
    TimeZone: boolean;
}